import { Box, Card, IconButton, Image, Text } from '@zillow/constellation-10';
import { IconCloseCircleFilled } from '@zillow/constellation-icons';
import AttachmentIcon from '../icons/AttachmentIcon';
import { cardStyles, fileNameStyles, imageThumbnailStyles } from './styles';

export type UploadedAttachmentPreviewCardProps = {
  fileName: string;
  fileType: string;
  imageSrc: string;
  onClick(zDocId: string): void;
  onRemove(zDocId: string): void;
  zDocId: string;
};

export default function UploadedAttachmentPreviewCard({
  fileName,
  fileType,
  imageSrc,
  onClick,
  onRemove,
  zDocId,
}: UploadedAttachmentPreviewCardProps) {
  const handleRemoveAttachment = (event: React.MouseEvent<HTMLButtonElement>) => {
    // NOTE: We are not able to delete files on the FE via the zDocs SDK at this time.
    event.stopPropagation();
    return onRemove(zDocId);
  };

  const handleViewImageAttachment = () => {
    return onClick(zDocId);
  };

  return (
    <Card
      data-testid="uploaded-attachment-preview-card"
      interactive={!!imageSrc}
      onClick={imageSrc ? handleViewImageAttachment : undefined}
      elevated={false}
      css={cardStyles}
    >
      {imageSrc ? (
        <>
          <Box css={imageThumbnailStyles}>
            <Image
              src={imageSrc}
              alt="Uploaded image attachment thumbnail"
              css={{
                objectFit: 'cover',
                width: '100%',
                height: '100%',
              }}
            />
          </Box>
          <Text
            textStyle="body-sm"
            css={{
              ...fileNameStyles,
              lgDown: {
                display: 'none',
              },
            }}
          >
            {fileName}
          </Text>
        </>
      ) : (
        <>
          <AttachmentIcon fileType={fileType} />
          <Text
            textStyle="body-sm"
            css={{
              ...fileNameStyles,
              maxWidth: {
                mdDown: '130px',
                lgDown: '200px',
              },
            }}
          >
            {fileName}
          </Text>
        </>
      )}

      <IconButton
        data-testid="remove-attachment-button"
        shape="square"
        emphasis="bare"
        className="remove-attachment-button"
        icon={<IconCloseCircleFilled />}
        onClick={handleRemoveAttachment}
        size="sm"
        title="Remove attachment"
        css={{
          marginLeft: 'auto',
        }}
      />
    </Card>
  );
}
